import React, { useState } from 'react';
import { Alert, Button, Card, CardContent, TextField } from '@mui/material';
import { LockKeyhole, Mail, Sparkles } from 'lucide-react';
import auth from '../utils/auth';
import { isSupabaseConfigured } from '../utils/supabaseClient';

export default function AuthPage({ onAuthSuccess }) {
    const [isLogin, setIsLogin] = useState(true);
    const [error, setError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        password: ''
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setIsSubmitting(true);

        try {
            if (isLogin) {
                await auth.login(formData.name, formData.password);
            } else {
                await auth.register(formData.name, formData.email, formData.password);
            }
            onAuthSuccess();
        } catch (err) {
            setError(err.message);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="app-surface min-h-screen flex items-center justify-center p-4">
            <div className="w-full max-w-md">
                <div className="mb-5 text-center">
                    <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-lg bg-teal-300 text-[#071014] shadow-[0_18px_60px_rgba(45,212,191,0.28)]">
                        <Sparkles size={28} />
                    </div>
                    <p className="text-xs uppercase tracking-[0.24em] text-teal-300/80">Financer</p>
                    <h1 className="mt-2 text-3xl font-bold text-white">
                        {isLogin ? 'Вход в систему' : 'Регистрация'}
                    </h1>
                </div>

                <Card className="w-full">
                    <CardContent className="space-y-4">
                        {error && (
                            <Alert severity="error" className="mb-4">
                                {error}
                            </Alert>
                        )}

                        <form onSubmit={handleSubmit} className="space-y-4">
                            <TextField
                                fullWidth
                                label={isSupabaseConfigured && isLogin ? 'Email' : 'Имя пользователя'}
                                value={formData.name}
                                onChange={(e) => setFormData(prev => ({ ...prev, name: e.target.value }))}
                                InputProps={{ startAdornment: <Mail size={18} className="mr-2 text-slate-400" /> }}
                            />

                            {!isLogin && (
                                <TextField
                                    fullWidth
                                    type="email"
                                    label="Email"
                                    value={formData.email}
                                    onChange={(e) => setFormData(prev => ({ ...prev, email: e.target.value }))}
                                />
                            )}

                            <TextField
                                fullWidth
                                type="password"
                                label="Пароль"
                                value={formData.password}
                                onChange={(e) => setFormData(prev => ({ ...prev, password: e.target.value }))}
                                InputProps={{ startAdornment: <LockKeyhole size={18} className="mr-2 text-slate-400" /> }}
                            />

                            <Button
                                type="submit"
                                variant="contained"
                                fullWidth
                                size="large"
                                disabled={isSubmitting}
                                sx={{
                                    background: 'linear-gradient(135deg, #2dd4bf, #f59e0b)',
                                    color: '#061014',
                                    minHeight: 48
                                }}
                            >
                                {isSubmitting ? 'Подождите...' : isLogin ? 'Войти' : 'Зарегистрироваться'}
                            </Button>
                        </form>

                        <div className="text-center">
                            <Button onClick={() => setIsLogin(!isLogin)} variant="text">
                                {isLogin ? 'Создать аккаунт' : 'Уже есть аккаунт'}
                            </Button>
                        </div>
                    </CardContent>
                </Card>
            </div>
        </div>
    );
}
